module.exports = __webpack_public_path__ + "static/media/safelite.7af2a31d.svg";